import { InjectionToken } from '@angular/core';

import { BaseCdsApi, CdsApiOptions } from './cds-api.service';

export type BaseCdsApiFactory = (options: CdsApiOptions) => BaseCdsApi;

const cdsFactory = (): BaseCdsApiFactory => (options: CdsApiOptions) => new BaseCdsApi().configure(options);

// This needs to be provided in root as multiple root services access it
// Making it non-root causes issues in the Host-App setup for Sports
// Todo - SportsRefactor: This should be moved to a root service, no reason to use an injection token for it.
// It's not overriden anywhere, only this one instance exists.
export const CDS_API_FACTORY = new InjectionToken<BaseCdsApiFactory>('CDS_API_FACTORY', {
    providedIn: 'root',
    factory: () => {
        return cdsFactory();
    },
});
